import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--app-bg)]">
      <div className="text-center">
        <img src="/img/404.jpg" alt="not found" className="w-1/4 h-1/4 m-auto"/>
        <p className="text-4xl text-[var(--app-text)] mb-4 font-bold">{t("auth.not_found.title")}</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          {t("auth.not_found.home")}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
